// extracted by mini-css-extract-plugin
export var actionText = "_sj-4";
export var container = "_sj-0";
export var leftSection = "_sj-1";
export var rightSection = "_sj-2";
export var settingsButton = "_sj-6";
export var settingsIcon = "_sj-7";
export var shortcut = "_sj-5";
export var shortcutGroup = "_sj-3";